import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import BaseDetailSheet from '../game/components/BaseDetailSheet';

interface AuthPromptModalProps {
  isOpen: boolean;
  isWorldApp: boolean;
  onClose: () => void;
  onLogin: () => void;
}

const AuthPromptModal: React.FC<AuthPromptModalProps> = ({
  isOpen,
  isWorldApp,
  onClose,
  onLogin,
}) => {
  const { t } = useTranslation();

  return (
    <BaseDetailSheet isOpen={isOpen} onClose={onClose} maxWidthClass="max-w-md" zIndex={70}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={t('auth.loginRequiredDescription')}
        className="relative overflow-hidden rounded-2xl border border-purple-400/30 bg-gradient-to-br from-gray-900 via-gray-900 to-purple-950/60 p-5 shadow-2xl sm:p-6"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label={t('common.close')}
          className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full text-gray-300 transition-colors hover:bg-white/10 hover:text-white"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center text-center">
          <p className="mt-2 max-w-xs text-sm leading-6 text-gray-300">
            {t('auth.loginRequiredDescription')}
          </p>

          <button
            type="button"
            onClick={onLogin}
            className="mt-6 flex min-h-12 w-full items-center justify-center gap-2 rounded-xl bg-purple-600 px-4 py-3 font-semibold text-white transition-colors hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 focus:ring-offset-gray-900"
          >
            <img
              src={isWorldApp ? '/image/logo/worldcoin.png' : '/image/logo/gg01.png'}
              alt={isWorldApp ? 'World ID' : 'GGMOMOMO'}
              className="h-5 w-5 object-contain"
              style={isWorldApp ? { filter: 'invert(1)' } : undefined}
            />
            <span>{isWorldApp ? t('auth.loginWithWorldId') : t('auth.login')}</span>
          </button>
        </div>
      </div>
    </BaseDetailSheet>
  );
};

export default AuthPromptModal;
